// deps
import React, { memo } from "react";

// hooks
import { useSplashLottie } from "@cart-client/hooks/useSplashLottie";

// internal-deps
import { LottieAnimation } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";
import { SPLASH_LOTTIE_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styles
import { LottieContainer } from "./styles";

interface SplashLottieProps {
    onImpression?: (tag: string) => void;
}

import { Portal } from "@swiggy-private/dls-web-core/dist/components/Portal";

export const SplashLottie = ({ onImpression }: SplashLottieProps) => {
    const { shouldRender, lottieData, handleLottieComplete, handleError } = useSplashLottie(onImpression);

    if (!shouldRender || isEmpty(lottieData)) {
        return null;
    }

    return (
        <Portal>
            <LottieContainer data-testid={SPLASH_LOTTIE_TEST_IDS.CONTAINER}>
                <div data-testid={SPLASH_LOTTIE_TEST_IDS.LOTTIE_ANIMATION}>
                    <LottieAnimation
                        animationData={lottieData}
                        visible={true}
                        playLottie={true}
                        autoplay={true}
                        loop={false}
                        backwardSpeed={1}
                        forwardSpeed={1}
                        playIfVisible={false}
                        onPlayComplete={handleLottieComplete}
                        onError={handleError}
                        preserveAspect="xMidYMid meet"
                        enableFrameEvent={false}
                    />
                </div>
            </LottieContainer>
        </Portal>
    );
};

export default memo(SplashLottie);
